import { collection, addDoc, getDocs, query, where, orderBy, doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

const ORDERS_COLLECTION = collection(db, "orders");

const normalizeOrder = (docSnap) => ({
  id: docSnap.id,
  ...docSnap.data(),
});

export async function listUserOrders(userId) {
  if (!userId) return [];
  const q = query(ORDERS_COLLECTION, where("userId", "==", userId), orderBy("createdAt", "desc"));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(normalizeOrder);
}

export async function getOrderById(orderId) {
  if (!orderId) return null;
  const orderRef = doc(db, "orders", orderId);
  const snapshot = await getDoc(orderRef);
  if (!snapshot.exists()) return null;
  return { id: snapshot.id, ...snapshot.data() };
}

export async function createOrder(order) {
  if (!order?.userId) {
    throw new Error("Order userId is required.");
  }

  const newOrder = {
    ...order,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    status: order.status || "pending",
  };

  const orderRef = await addDoc(ORDERS_COLLECTION, newOrder);
  return { id: orderRef.id, ...newOrder };
}

const ordersApi = {
  listUserOrders,
  getOrderById,
  createOrder,
};

export default ordersApi;